import type { ConnectionStatus, Filter, MigrationStatus } from './types'

const URLFilterKeys = {
    deviceGroups: 'dg',
    connectionStatus: 'cs',
    migration: 'mg',
    chains: 'ch',
}

/**
 * Decode a URL search string as filter form data
 * @param searchString URL search string
 * @returns 
 */
function decodeFilter(searchString: string): Partial<Filter> {
    const sp = new URLSearchParams(searchString)

    const decodeParam = <T = string>(
        filterKey: keyof typeof URLFilterKeys,
        formatter?: (v: string) => T,
    ): T[] | undefined => {
        if (!sp.has(URLFilterKeys[filterKey])) {
            return undefined
        }

        let decodedArray = sp.get(URLFilterKeys[filterKey])?.split(',').filter(v => !!v) ?? []

        console.log({decodedArray, elem: sp.get(URLFilterKeys[filterKey]), key: filterKey})

        if (typeof formatter === 'function') {
            return decodedArray.map<T>(formatter)
        }

        return decodedArray as T[]
    }
    
    return {
        deviceGroups: decodeParam('deviceGroups', (v) => parseInt(v))?.filter(v => !isNaN(v)),
        connectionStatus: decodeParam('connectionStatus')?.filter(
            (v) => ['online', 'offline'].includes(v)
        ) as ConnectionStatus[],
        migration: decodeParam('migration')?.filter(
            (v) => ['migrated', 'not-migrated'].includes(v)
        ) as MigrationStatus[],
        chains: decodeParam('chains', (v) => parseInt(v))?.filter(v => !isNaN(v)),
    }
}

/**
 * Encodes values for a filter form as a URL search string
 * @param filter 
 * @returns 
 */
function encodeFilter({
    deviceGroups,
    connectionStatus,
    migration,
    chains,
}: Filter): string {
    return new URLSearchParams({
        [URLFilterKeys.deviceGroups]: deviceGroups.join(),
        [URLFilterKeys.connectionStatus]: connectionStatus.join(),
        [URLFilterKeys.migration]: migration.join(),
        [URLFilterKeys.chains]: chains.join(),
    }).toString()
}

export { decodeFilter, encodeFilter }